
export enum SJQXChecks {
  SCGHSJ = 'delete_registered_data', //删除挂号数据
  CKLRSJ = 'view_profit_data', //查看利润数据
  DCDYQX = 'export_print_permission', //导出/打印权限
  YSCKJYCX = 'doctor_view_transaction',//医生查看交易查询
}

export const JQXCheckOptions = [
  SJQXChecks.SCGHSJ,
  SJQXChecks.CKLRSJ,
  SJQXChecks.DCDYQX,
  SJQXChecks.YSCKJYCX,
]

export function getSJQXChecksName(value: SJQXChecks) {
  switch (value) {
    case 'delete_registered_data':
      return '删除挂号数据'
    case 'view_profit_data':
      return '查看利润数据'
    case 'export_print_permission':
      return '导出/打印权限'
    case 'doctor_view_transaction':
      return '医生查看交易查询'
    default:
      break
  }
}

export enum SCGHSJType {
  YGHCDKBJ = 1,
  JGLYKBJ = 2,
  ZDCYKBJ = 99
}

export const SCGHSJTypeOptions = [
  SCGHSJType.YGHCDKBJ,
  SCGHSJType.JGLYKBJ,
  SCGHSJType.ZDCYKBJ,
]

export const SCGHSJTypeOption = [
  SCGHSJType.JGLYKBJ,
  SCGHSJType.ZDCYKBJ,
]


export function getSCGHSJTypeName(type: SCGHSJType) {
  switch (type) {
    case 1:
      return '有挂号菜单可编辑'
    case 2:
      return '仅管理员可编辑'
    case 99:
      return '指定成员可编辑'
    default:
      break
  }
}

export enum CKLRSJType {
  YGHCDKBJ = 1,
  JGLYKBJ = 2,
  ZDCYKBJ = 99
}

export const CKLRSJTypeOptions = [
  CKLRSJType.YGHCDKBJ,
  CKLRSJType.JGLYKBJ,
  CKLRSJType.ZDCYKBJ,
]

export function getCKLRSJTypeName(type: CKLRSJType) {
  switch (type) {
    case 1:
      return '有菜单权限可查看'
    case 2:
      return '仅管理员权限可查看'
    case 99:
      return '指定成员可查看'
    default:
      break
  }
}

export enum DCDYQXType {
  YGHCDKBJ = 1,
  JGLYKBJ = 2,
  ZDCYKBJ = 99
}

export const DCDYQXTypeOptions = [
  DCDYQXType.YGHCDKBJ,
  DCDYQXType.JGLYKBJ,
  DCDYQXType.ZDCYKBJ,
]

export function getDCDYQXTypeName(type: DCDYQXType) {
  switch (type) {
    case 1:
      return '有菜单权限可导出/打印'
    case 2:
      return '仅管理员权限可导出/打印'
    case 99:
      return '指定成员可导出/打印'
    default:
      break
  }
}

export enum YSCKJYCXType {
  YGHCDKBJ = 1,
  JGLYKBJ = 2,
}

export const YSCKJYCXTypeOptions = [
  YSCKJYCXType.YGHCDKBJ,
  YSCKJYCXType.JGLYKBJ,
]

export function getYSCKJYCXTypeName(type: YSCKJYCXType) {
  switch (type) {
    case 1:
      return '只允许查看自己的患者'
    case 2:
      return '允许查看所有的患者'
    default:
      break
  }
}

